import type { SharedVarsMap } from '@amzn/journeys-common';
import {
  REMOTE_SEARCH_ONTOLOGY_BRANDS_COLLECTIONS_ASIN,
  REMOTE_SEARCH_ONTOLOGY_LIFESTYLE,
  REMOTE_SEARCH_ONTOLOGY_LIFESTYLE_ASIN,
  REMOTE_SEARCH_ONTOLOGY_VIDEO,
  REMOTE_SEARCH_ONTOLOGY_VIDEO_ASIN,
} from '../constants';
import { FEATURED_BRANDS_TEMPLATES, type FeaturedBrandsContent } from '../types';
import { hasProgramAsins } from './hasProgramAsins';

/**
 * Determines the appropriate remote search ontology based on creative type and content
 *
 * @param {FEATURED_BRANDS_TEMPLATES} creativeType - The type of featured brands template
 * @param {FeaturedBrandsContent} content - The featured brands content data
 * @param {SharedVarsMap} sharedVarsMap - Map of shared variables
 * @returns {string} The appropriate remote search ontology value
 * @throws {Error} If the creativeType is not a valid FEATURED_BRANDS_TEMPLATES value
 */
export const getRemoteSearchOntology = (
  creativeType: FEATURED_BRANDS_TEMPLATES,
  content: FeaturedBrandsContent,
  sharedVarsMap: SharedVarsMap,
): string => {
  const hasAsins = hasProgramAsins(content, sharedVarsMap);

  switch (creativeType) {
    case FEATURED_BRANDS_TEMPLATES.LIFESTYLE_PRODUCT_COLLECTION:
      return hasAsins ? REMOTE_SEARCH_ONTOLOGY_LIFESTYLE_ASIN : REMOTE_SEARCH_ONTOLOGY_LIFESTYLE;
    case FEATURED_BRANDS_TEMPLATES.VIDEO:
      return hasAsins ? REMOTE_SEARCH_ONTOLOGY_VIDEO_ASIN : REMOTE_SEARCH_ONTOLOGY_VIDEO;
    case FEATURED_BRANDS_TEMPLATES.BRANDS_COLLECTIONS:
      // BRANDS_COLLECTIONS always requires ASINs
      return REMOTE_SEARCH_ONTOLOGY_BRANDS_COLLECTIONS_ASIN;
    default:
      throw new Error(`Invalid creative type: ${creativeType}`);
  }
};
